/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AffiliateResponseActiveReferrals
 */
export interface AffiliateResponseActiveReferrals {
  /**
   *
   * @type {number}
   * @memberof AffiliateResponseActiveReferrals
   */
  totalMembers?: number
}

export function AffiliateResponseActiveReferralsFromJSON(json: any): AffiliateResponseActiveReferrals {
  return AffiliateResponseActiveReferralsFromJSONTyped(json, false)
}

export function AffiliateResponseActiveReferralsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AffiliateResponseActiveReferrals {
  if (json === undefined || json === null) {
    return json
  }
  return {
    totalMembers: !exists(json, 'totalMembers') ? undefined : json['totalMembers'],
  }
}

export function AffiliateResponseActiveReferralsToJSON(value?: AffiliateResponseActiveReferrals | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    totalMembers: value.totalMembers,
  }
}
